export default __webpack_public_path__ + "static/media/ppi-onepack.fe4d954b.svg";